import { categoriesInvalidOnNorm5, isNormEqualOrGreater10 } from "pages/UploadCertificate/validationRules/utils";

import { getCertificateCreateFieldSelector } from "raft/CertificateForm";
import { useMemo } from "react";
import { useRecoilValue } from "recoil";
import raftEnums from "raft/internal/enums";

const categories = raftEnums.category;

// Categories to exclude ONLY in grid forming certificates
const GRID_FORMING_EXCLUDED_CATEGORIES = [
  "UNDERVOLTAGE_PROTECTION", // NA-Schutz
  "PAV_E_MONITORING", // PAVE
  "VOLTAGE_REGULATOR", // Spannungsregler
  "PROTECTIVE_DEVICE_INTERMEDIATE", // Schutzgerät (Zwischengelagert)
  "EZA_CONTROLLER", // EZA-Regler
  "OTHER", // Andere
];

export const useGetCategoryOptions = (isGridForming = false) => {
  const normListAtomActive = useMemo(
    () => getCertificateCreateFieldSelector({ formVersion: "active" })("__normList"),
    []
  );
  const normListAtomMatrix = useMemo(
    () => getCertificateCreateFieldSelector({ formVersion: "matrixCertificateCreate" })("__normList"),
    []
  );

  const activeNormsActive = useRecoilValue(normListAtomActive);
  const activeNormsMatrix = useRecoilValue(normListAtomMatrix);

  // Use whichever form has norm data
  const activeNorms = activeNormsMatrix || activeNormsActive;
  const options = useMemo(() => {
    const normIs10Up = isNormEqualOrGreater10({ __normList: activeNorms });
    const options = Object.entries(categories)
      .filter(([value]) => {
        // In grid forming form, exclude specific categories
        if (isGridForming && GRID_FORMING_EXCLUDED_CATEGORIES.includes(value)) {
          return false;
        }
        return true;
      })
      .map(([value, label]) => ({
        disabled: !normIs10Up && categoriesInvalidOnNorm5.includes(value),
        value,
        label,
      }));
    return options;
  }, [activeNorms, isGridForming]);

  return options;
};
